import * as amplitude from "@amplitude/analytics-browser";
import { isAmplitudeReady } from "./initAmplitude";

// Só o que a análise precisa: deixa explícito que o token do Firebase e as
// permissões do admin não saem daqui para o Amplitude.
export type TAmplitudeUser = {
  uid?: string | null;
  email?: string | null;
  displayName?: string | null;
};

export const setAmplitudeUser = (user: TAmplitudeUser) => {
  // Sem init não há cliente: o SDK v2 enfileira a chamada e reclama no console
  // uma vez por chamada, e todo caminho de login passa por aqui.
  if (!isAmplitudeReady()) return;

  // Sem uid não há o que identificar: `setUserId(undefined)` apagaria a
  // identificação em silêncio e o `identify` abaixo gravaria email e nome num
  // perfil anônimo, que é justamente o que este caminho existe para evitar.
  if (!user.uid) return;

  // O uid do Firebase é a chave estável do usuário e é o mesmo id que o CPMS
  // usa, que é o que faz a mesma pessoa ser um usuário só nos dois sistemas.
  // `firebase_uid` vai junto como user property para servir de de-para numa
  // eventual troca de autenticação.
  amplitude.setUserId(user.uid);

  const identify = new amplitude.Identify().set("firebase_uid", user.uid);

  // Admin criado pelo painel não tem `displayName`, e o perfil é compartilhado
  // com o CPMS pelo mesmo `user_id`: um `|| ""` aqui apagaria o `name` que o
  // CPMS preencheu. Omitir é o que o tupi-cpms-frontend já faz.
  if (user.email) identify.set("email", user.email);
  if (user.displayName) identify.set("name", user.displayName);

  amplitude.identify(identify);
};

export const resetAmplitudeUser = () => {
  if (!isAmplitudeReady()) return;

  amplitude.reset();
};

// Com o autocapture desligado, este é o único caminho de evento do admin: o que
// não passa por aqui não existe no Amplitude. O nome vem da taxonomia do
// projeto, que o CPMS já usa, para os dois produtos somarem no mesmo funil.
export const trackEvent = (name: string, data?: Record<string, unknown>) => {
  if (!isAmplitudeReady()) return;

  amplitude.track(name, data);
};
